import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import RecensionePage from "@/pages/recensione/page";
import SicurezzaPage from "@/pages/sicurezza/page";
import ConfrontoPage from "@/pages/confronto/page";
import GuidaAcquistiPage from "@/pages/guida-acquisti/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/itaobuy-spreadsheet-guida",
    element: <ArticlePage />,
  },
  {
    path: "/itaobuy-spreadsheet-recensione",
    element: <RecensionePage />,
  },
  {
    path: "/itaobuy-spreadsheet-sicurezza",
    element: <SicurezzaPage />,
  },
  {
    path: "/itaobuy-spreadsheet-confronto",
    element: <ConfrontoPage />,
  },
  {
    path: "/itaobuy-spreadsheet-guida-acquisti",
    element: <GuidaAcquistiPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;